import { Box } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const SummaryContainer = styled(Box)`
  background: rgba(251, 251, 251, 1);
  border-radius: 4px;
  padding: ${({ theme: { mp } }) => mp.sm};
  margin-top: ${({ theme: { mp } }) => mp.sm};
`
